import { useStytch } from '@stytch/react'
import axios, { AxiosInstance } from 'axios'
import { useMemo } from 'react'

const useAxiosWithAuth = (): AxiosInstance => {
  const stytch = useStytch()

  const axiosInstance = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_SERVER_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    instance.interceptors.request.use((config) => {
      if (!stytch.session.getTokens()) {
        throw new Error('No session found')
      }

      const accessToken = stytch.session.getTokens()?.session_jwt

      if (accessToken) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        }
      }

      return config
    })

    return instance
  }, [stytch])

  return axiosInstance
}

export default useAxiosWithAuth
